import { Transition as $ } from './Transition.js';
import { TransitionFade } from './TransitionFade.js';
export * from './Transition.js';
export * from './TransitionFade.js';

export const Transition = Object.assign($, {
  Fade: TransitionFade,
});
